<template>
    <div>
      <!-- 宠物状态概览 -->
      <div class="bg-white rounded-2xl shadow-lg theme-gradient-bg">
        <!-- 3D模型展示区 -->
        <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4">
          <div class="aspect-video flex items-center justify-center bg-white bg-opacity-50 rounded-lg">
            <div class="text-center floating">
              <Dog ref="dogRef" @onDogReady="onDogReady"></Dog>
            </div>
          </div>
          <div>
            <TimeLine ref="mentPageRef" :listTime="list" @setTime="getTimes" @dragTime="setDragTime" @stateChange="stateChange"/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex'
  import { RPC } from '@/api/rpc'
  import Dog from '@/components/dog.vue'
  import SegmentPage from '@/components/Segment.vue';
  import dayjs from 'dayjs'
  import TimeLine from '@/components/timeLine.vue'
  export default {
    name: 'Home',
    components: {
      Dog,SegmentPage,TimeLine
    },
    data() {
      return {
        lookStatus: false,
        s: 0,
        list: [],
        runStatu: 0,
        lyingStatu: 0,
        walkingStatu: 0,
        standingStatu: 0,
        sittingStatu: 0,
        eattingStatu: 0,
        timerId: null,
        timer: null,
        startTime: '',
        endTime: '',
        petInfo: {
        },
        machineId: null,
        machineStatus: 'green',
        eatNum: null,
      }
    },
    beforeDestroy() {
      clearInterval(this.timerId)
      clearInterval(this.timer)
    },
    computed: {
      ...mapGetters(['currentDevice'])
    },
    methods: {
      ...mapActions(['updateDevices']),
      lookFun() {
        this.lookStatus = !this.lookStatus
        // if (this.lookStatus) {
          clearInterval(this.timerId)
          this.timerId = null
          this.endTime = new Date().getTime();
          this.startTime = new Date().getTime() - 2 * 60 * 60 * 1000
          this.getPestList()
        // } else {
        //   clearInterval(this.timer)
        //   this.timer = null
        //   this.getPetInfo()
        // }
      },
      getPet(machineId) {
        // running 跑,sitting 坐,standing 站立,walking 行走,lying 爬,eatting 吃
        RPC.getPetStatus({machineId}).then(res=>{
          if (res.data.attitude == "running" && this.runStatu == 0) {
            this.runStatu = 1
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onRun()
          }
          if (res.data.attitude == "sitting" && this.sittingStatu == 0) {
            this.sittingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onSitting()
          }
          if (res.data.attitude == "standing" && this.standingStatu == 0) {
            this.standingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onStanding()
          }
          if (res.data.attitude == "walking" && this.walkingStatu == 0) {
            this.walkingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onWalking()
          }
          if (res.data.attitude == "lying" && this.lyingStatu == 0) {
            this.lyingStatu = 1
            this.runStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onLying()
          }
          if (res.data.attitude == "eatting" && this.eattingStatu == 0) {
            this.eattingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.$refs.dogRef.onEat()
          }
        })
      },
      setDragTime(row) {
        this.s = row.currentIndex
        if (this.s == this.list.length || this.s == -1) {
            clearInterval(this.timer)
            this.timer = null
            return
          }
          // 使用映射表替代多层if-else
          this.time = this.list[this.s].receivedTime
          // let selList = this.list[this.s]
          let selList = row.pointerValue.status
          if (selList == "running" && this.runStatu == 0) {
            this.runStatu = 1
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onRun()
          }
          if (selList == "sitting" && this.sittingStatu == 0) {
            this.sittingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onSitting()
          }
          if (selList == "standing" && this.standingStatu == 0) {
            this.standingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onStanding()
          }
          if (selList == "walking" && this.walkingStatu == 0) {
            this.walkingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onWalking()
          }
          if (selList == "lying" && this.lyingStatu == 0) {
            this.lyingStatu = 1
            this.runStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onLying()
          }
          if (selList == "eatting" && this.eattingStatu == 0) {
            this.eattingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.$refs.dogRef.onEat()
          }
        // clearInterval(this.timer)  
        // this.setTimeStatu()
      },
      stateChange(e) {
        console.log('2345',e)
        if (e.isPausedByDrag) {
  
        }
      },
      getTimes(item) {
        this.s = 0
        this.endTime = item.endTime
        this.startTime = item.startTime
        clearInterval(this.timer)  
        this.getPestList()
      },
      getPestList() {
        let data = {
          "endTime": dayjs(this.endTime).format('YYYY-MM-DD HH:mm:ss'),
          "machineId": this.machineId,
          "pageIndex": 1,
          "pageSize": 7200,
          "startTime": dayjs(this.startTime).format('YYYY-MM-DD HH:mm:ss'),
        }
        RPC.petsList(data).then(res=>{
          this.list = res.list
          res.list.map(item=>{
            item.times = new Date(item.receivedTime).getTime()
          })
          this.list = this.fixMissingTimestamps(res.list)
          this.$refs.mentPageRef.getList(this.list)
          this.setTimeStatu()
        })
      },
      fixMissingTimestamps(data) {
        // 1. 提取并转换时间戳（秒级）
        const seconds = data.map(item => Math.floor(item.times / 1000)).sort((a, b) => a - b);
        // 2. 补全缺失时间
        const complete = [];
        for (let i = 0; i < seconds.length; i++) {
          complete.push(seconds[i]);
          if (i === seconds.length - 1) break;
          const current = seconds[i];
          const next = seconds[i + 1];
          const gap = next - current;
          if (gap > 1) {
            for (let j = current + 1; j < next; j++) {
              complete.push(j);
            }
          }
        }
        // 3. 生成完整结果（转换回毫秒级）
        return complete.map(sec => ({
          times: sec * 1000,
          attitude:data.find(item => Math.floor(item.times / 1000) === sec)?.attitude ?? 'standing',
          receivedTime: new Date(sec * 1000).toLocaleString('zh-CN', { 
            hour12: false, 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit', 
            hour: '2-digit', 
            minute: '2-digit', 
            second: '2-digit' 
          }).replace(/\//g, '-')
        }));
      },
      setTimeStatu() {
        if (this.list.length==0) {
          clearInterval(this.timer)
          this.timer = null
          return
        }
          let selList = this.list[this.s]
          console.log('selList',selList)
          if (selList.attitude == "running" && this.runStatu == 0) {
            this.runStatu = 1
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onRun()
          }
          if (selList.attitude == "sitting" && this.sittingStatu == 0) {
            this.sittingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onSitting()
          }
          if (selList.attitude == "standing" && this.standingStatu == 0) {
            this.standingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onStanding()
          }
          if (selList.attitude == "walking" && this.walkingStatu == 0) {
            this.walkingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onWalking()
          }
          if (selList.attitude == "lying" && this.lyingStatu == 0) {
            this.lyingStatu = 1
            this.runStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onLying()
          }
          if (selList.attitude == "eatting" && this.eattingStatu == 0) {
            this.eattingStatu = 1
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.$refs.dogRef.onEat()
          }
          
          // this.s = this.s + 1
        // }, 1000)
      },
      setMachineRate(){
        let data = {
          "machineId": this.machineId,
          "rate": 1
        }
        RPC.updateSpeed(data).then(res=>{
          console.log('11',res)
        })
      },
      getPetInfo() {
        clearInterval(this.timerId);
        RPC.machineInfo({machineId: this.machineId}).then(res=>{
          if (res.data.machineStatus == 'offline') {
            this.machineStatus = 'gray'
            clearInterval(this.timerId);
            this.timerId = null;
            this.runStatu = 0
            this.lyingStatu = 0
            this.walkingStatu = 0
            this.standingStatu = 0
            this.sittingStatu = 0
            this.eattingStatu = 0
            this.$refs.dogRef.onStanding()
          } else {
            this.machineStatus = 'green'
            this.timerId = setInterval(() => {
              this.getPet(this.machineId)
            }, 1000)
            this.setMachineRate()
          }
          this.petInfo = res.data
          this.getPetList()
        })
      },
      getPetList() {
        RPC.getPetList({
          "pageIndex": 1,
          "pageSize": 100,
          "variety": "",
          "varietyType": this.petInfo.varietyType
        }).then(res=>{
        })
      },
      onDogReady(e) {
        // this.getPetInfo()
      }
    },
    beforeMount(){
      const hash = window.location.hash;
      // 分离路由和参数
      const queryString = hash.split('?')[1];
      // 解析参数
      const urlParams = new URLSearchParams(queryString);
      const token = urlParams.get('token');
      const deviceCode = urlParams.get('deviceCode');
      localStorage.setItem('token',token)
      sessionStorage.setItem('deviceCode',deviceCode)
      console.log('1111111111',token,deviceCode)
    },
    mounted() {
      document.title = '查看回放'
      this.machineId = sessionStorage.getItem('deviceCode')?sessionStorage.getItem('deviceCode') : null
      this.endTime = new Date().getTime();
      this.startTime = new Date().getTime() - 2 * 60 * 60 * 1000
      this.lookFun()
      
    }
  }
  </script>
  
  <style scoped>
  body {
    background-color: var(--background-color);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }
  
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-5px); }
    100% { transform: translateY(0px); }
  }
  
  .floating {
    animation: float 3s ease-in-out infinite;
  }
  .playIcon {
    width: 20px;
    height: 20px;
  }
  </style> 